import { useEffect } from "react";
import useHasChanged from "hooks/useHasChanged";
import usePaginationManager from "hooks/usePaginationManager";

export const useGetPaginatedQuestions = (search, active, topic, chapter) => {
  const searchHasChanged = useHasChanged(search);
  const activeHasChanged = useHasChanged(active);
  const topicHasChanged = useHasChanged(topic);
  const chapterHasChanged = useHasChanged(chapter);
  const { getPackage, reset, makeLoader } = usePaginationManager(
    "/api/questions",
    100
  );

  useEffect(() => {
    if (
      searchHasChanged ||
      activeHasChanged ||
      topicHasChanged ||
      chapterHasChanged
    ) {
      reset();
      loadNextPage();
    }
  });

  const more = [
    {
      qname: "active",
      value: active,
    },
    {
      qname: "topic",
      value: topic,
    },
    {
      qname: "chapter",
      value: chapter,
    },
  ];

  const loadNextPage = makeLoader(search, more);

  return getPackage(loadNextPage);
};

export default useGetPaginatedQuestions;
